export default __webpack_public_path__ + "3a99511b22935c3935a8a2e43496d006.png";